import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import moment from 'moment';

import { Spinner, Avatar, MCButton } from 'src/components/basic';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { countFormat, lang, userFullName, withRouter } from 'src/helpers';

import userModel from 'src/model';

import model from './model';
import LANG_CONST from '../../../../helpers/lang/const';
import { popupModel } from '../../../../components/complex';
import InvitationPopup from '../../../../components/user/InvitationPopup';

class Notification extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    userModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    userModel.unsubscribe(this.subscription);
    model.emit('resetNotifications');
  }

  onSubmit = (e) => {
    e.preventDefault();
    model.clearAll();
  };

  renderItem = (index, item) => {
    let fullname = userFullName(item);
    let name = <span className={'mc-name'}>{(item.isDoctor ? 'Dr. ' : ' ') + fullname}</span>;
    let value;
    let avatar = item.avatar && item.avatar.toString().replace('/full_', '/350_');
    let iconImage = <Avatar width={60} height={60} text={fullname} image={avatar} />;
    switch (item.nType) {
      case 'appointment':
      case 'appointment_create':
        value = (
          <span>
            {name}
            {' booked an appointment'}
          </span>
        );
        break;
      case 'appointment_cancel':
        value = (
          <span>
            {name}
            {' cancelled an appointment'}
          </span>
        );
        break;
      case 'appointment_approved':
        value = (
          <span>
            {'Your appointment has been approve with '}
            {name}
          </span>
        );
        iconImage = <SVGIcon iconname={'notification-approved-icon'} />;
        break;
      case 'like':
        value = (
          <span>
            {name} {' liked your post'}
          </span>
        );
        break;
      case 'reply':
        value = (
          <span>
            {name} {' replied to your post'}
          </span>
        );
        break;
      case 'invite':
        item.nItemText = lang.t(LANG_CONST.text.invite_doctor_title, { attr: userFullName(item) });
        value = <span>{item.nItemText}</span>;
        break;
      default:
        // console.log('notification renderItem', item);
        value = (
          <span>
            {name} {item.nItemText}
          </span>
        );
        break;
    }

    return (
      <div
        className={'mc-notification-item'}
        key={'mc-message-' + item.id}
        onClick={() => {
          if (item.nType === 'invite')
            return popupModel.setActivePopup('invitation_popup', {
              component: InvitationPopup,
              active: true,
              props: {
                data: { ...item, title: item.nItemText }
              }
            });
          this.props.router.navigate(
            (this.props.isAdmin ? '/admin' : '') + '/messages/' + item.nUserId,
            { state: { tab: 'chat' } }
          );
        }}
      >
        {iconImage}
        <div className={'mc-info'}>
          <div className={'mc-text'}>{value}</div>
          <div className={'mc-time'}>{moment(item.created).fromNow()}</div>
        </div>
      </div>
    );
  };

  render() {
    const items = model.items();
    let noResults = model.noResults();
    let loading = model.refreshing();
    let unread = userModel.getState().profile?.unreadNotifications || 0;

    return (
      <form className={'mc-setting-notification'} style={{ flex: '1 1' }} onSubmit={this.onSubmit}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>
            {lang.t('Notification')}
            <div data-testid='settings-notification-note' className={'mc-note'}>{`You have unread ${countFormat(
              unread
            )} notifications`}</div>
          </div>
          <MCButton primary light radius label={'Clear All'} type={'submit'} />
        </div>
        <Virtuoso
          data={items}
          components={{
            Footer: () => (
              <div style={{ textAlign: 'center', padding: '1rem' }}>
                {noResults && <div>{lang.t('No results yet')}</div>}
                {loading && <Spinner />}
              </div>
            )
          }}
          endReached={() => {
            if (model.hasMore() && !model.refreshing()) model.loadMore();
          }}
          itemContent={this.renderItem}
        />
      </form>
    );
  }
}

export default withRouter(Notification);
